<template>
  <div class="divider" />
</template>

<script>
export default {
  name: "divider"
}
</script>

<style scoped>
.divider {
  height: 13px;
  width: 100%;
  margin-bottom: 12px;
  border-bottom: 1px solid #555;
}
</style>